import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShortageHeader from '../../../ObjectCard/ProposalShortage/ShortageHeader';
import TeamShortageTable, { type TeamShortageRow } from './TeamShortageTable';

export type { TeamShortageRow };

interface TeamProposalShortageProps {
    kind: 'products' | 'services';
    proposalName: string;
    items: TeamShortageRow[];
    canAdd: boolean;
    addingKey?: string;
    onAdd: (item: TeamShortageRow) => void;
}

const TeamProposalShortage = ({
    kind,
    proposalName,
    items,
    canAdd,
    addingKey,
    onAdd,
}: TeamProposalShortageProps) => {
    const { t } = useTranslation(['Objects']);
    const [expanded, setExpanded] = useState(false);

    if (!items.length) return null;

    const title =
        kind === 'products'
            ? t('proposalShortage.titleProducts')
            : t('proposalShortage.titleServices');
    const hint = proposalName
        ? t('proposalShortage.hint', { name: proposalName })
        : t('proposalShortage.hintDefault');
    const allMissing = items.every((item) => !(Number(item.have) > 0));
    const tone = allMissing ? 'shortage' : 'partial';

    return (
        <div
            className={`object-analytics-payments object-analytics-payments--${tone} proposal-shortage${
                expanded ? ' proposal-shortage--expanded' : ' proposal-shortage--collapsed'
            }`}
            role="status"
        >
            <div className="object-analytics-payments__glow" aria-hidden="true" />
            <ShortageHeader
                title={title}
                hint={hint}
                expanded={expanded}
                allMissing={allMissing}
                onToggle={() => setExpanded((prev) => !prev)}
            />
            {expanded && (
                <TeamShortageTable
                    kind={kind}
                    items={items}
                    canAdd={canAdd}
                    addingKey={addingKey}
                    onAdd={onAdd}
                />
            )}
        </div>
    );
};

export default TeamProposalShortage;
